// import { useEffect, useState } from "react";
// import { Button, Form, Input, Modal, Spin, message } from "antd";
// import { useUserContext } from "../context/dashboard-context";
// import NewsCard from "../components/product-card/news-card";
// import CustomPagination from "../components/pagination";
// import NewsImageUploader from "../components/imageUploader/NewsImageUploader";
// import api from "../context/api";
// import './news-page.scss';

// const { TextArea } = Input;

// const NewsPage = () => {
//   const { token } = useUserContext();
//   const [loading, setLoading] = useState(false);
//   const [news, setNews] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalNews, setTotalNews] = useState(0);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [form] = Form.useForm();

//   const [formData, setFormData] = useState({
//     title_uz: "",
//     title_ru: "",
//     title_en: "",
//     text_uz: "",
//     text_ru: "",
//     text_en: "",
//     images: []
//   });
//   const fetchNews = async (page = 1) => {
//     setLoading(true);
//     try {
//       const response = await api.get(`/news/?page=${page}`);
      
//       // Handle different response structures
//       const data = Array.isArray(response.data) 
//         ? response.data 
//         : response.data.data || response.data.results || [];
        
//       setNews(data);
//       setTotalNews(response.data?.totalCount || response.data?.count || data.length);
//     } catch (error) {
//       console.error("Error fetching news:", error);
//       message.error("Yangiliklarni yuklashda xatolik yuz berdi");
//     } finally {
//       setLoading(false);
//     }
//   };

//   console.log("FormData contents:");


//   const addNews = async () => {
//     if (formData.images.length === 0) {
//       message.error("Iltimos, kamida bitta rasm yuklang");
//       return;
//     }
  
//     setLoading(true);
//     const formDataToSend = new FormData();
    
//     // Append text fields
//     Object.entries(formData).forEach(([key, value]) => {
//       if (key !== 'images' && value !== null && value !== undefined) {
//         formDataToSend.append(key, value);
//       }
//     });
    
//     // Append images with correct field name
//     formData.images.forEach((image) => {
//       formDataToSend.append('image_files', image); // or 'images' depending on backend
//     });
  
//     // Debugging - log what's being sent
//     console.log("FormData contents:");
//     for (let [key, value] of formDataToSend.entries()) {
//       console.log(key, value);
//     }
  
//     try {
//       const response = await api.post("/news/", formDataToSend, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: `Bearer ${token}`
//         },
//       });
  
//       if ([200, 201].includes(response.status)) {
//         message.success("Yangilik muvaffaqiyatli qo'shildi");
//         fetchNews(currentPage);
//         form.resetFields();
//         setFormData({
//           title_uz: "",
//           title_ru: "",
//           title_en: "",
//           text_uz: "",
//           text_ru: "",
//           text_en: "",
//           images: []
//         });
//         setIsModalOpen(false);
//       }
//     } catch (error) {
//       console.error("Error adding news:", error);
//       message.error(error.response?.data?.message || "Yangilik qo'shishda xatolik yuz berdi");
//     } finally {
//       setLoading(false);
//     }
//   };



//   useEffect(() => {
//     fetchNews();
//   }, []);

//   const handleFormChange = (field, value) => {
//     setFormData(prev => ({ ...prev, [field]: value }));
//   };

//   return (
//     <div className="news-page">
//       <div className="page-header">
//         <h1>Yangiliklar</h1>
//         <button onClick={() => setIsModalOpen(true)}>
//           + Yangi yangilik qo'shish
//         </button>
//       </div>

//       {loading && news.length === 0 ? (
//         <Spin size="large" />
//       ) : news.length > 0 ? (
//         <>
//           <div className="news-grid">
//             {news.map(item => (
//               <NewsCard
//                 key={item.id}
//                 news={item}
//                 onUpdate={fetchNews}
//               />
//             ))}
//           </div>
          
//           <CustomPagination
//             current={currentPage}
//             total={totalNews}
//             onChange={(page) => {
//               setCurrentPage(page);
//               fetchNews(page);
//             }}
//           />
//         </>
//       ) : (
//         <div className="no-news">
//           <p>Hozircha yangiliklar mavjud emas. Birinchi yangilikni qo'shing.</p>
//         </div>
//       )}

//       <Modal
//         title="Yangi yangilik qo'shish"
//         open={isModalOpen}
//         onCancel={() => {
//           setIsModalOpen(false);
//           form.resetFields();
//         }}
//         footer={null}
//         width={800}
//       >
//         <Spin spinning={loading}>
//           <Form form={form} onFinish={addNews}>
//             <div className="form-section">
//               <Form.Item label="Rasmlar" required>
//                 <NewsImageUploader
//                   images={formData.images}
//                   setImages={(images) => handleFormChange('images', images)}
//                 />
//               </Form.Item>
              
//               <Form.Item label="Sarlavha (O'zbekcha)" required>
//                 <Input
//                   value={formData.title_uz}
//                   onChange={(e) => handleFormChange('title_uz', e.target.value)}
//                 />
//               </Form.Item>
              
//               <Form.Item label="Sarlavha (Ruscha)" required>
//                 <Input
//                   value={formData.title_ru}
//                   onChange={(e) => handleFormChange('title_ru', e.target.value)}
//                 />
//               </Form.Item>
              
//               <Form.Item label="Sarlavha (Inglizcha)">
//                 <Input
//                   value={formData.title_en}
//                   onChange={(e) => handleFormChange('title_en', e.target.value)}
//                 />
//               </Form.Item>
              
//               <Form.Item label="Matn (O'zbekcha)" required>
//                 <TextArea
//                   rows={4}
//                   value={formData.text_uz}
//                   onChange={(e) => handleFormChange('text_uz', e.target.value)}
//                 />
//               </Form.Item>
              
//               <Form.Item label="Matn (Ruscha)">
//                 <TextArea
//                   rows={4}
//                   value={formData.text_ru}
//                   onChange={(e) => handleFormChange('text_ru', e.target.value)}
//                 />
//               </Form.Item>
              
//               <Form.Item label="Matn (Inglizcha)">
//                 <TextArea
//                   rows={4}
//                   value={formData.text_en}
//                   onChange={(e) => handleFormChange('text_en', e.target.value)}
//                 />
//               </Form.Item>
//             </div>
            
//             <div className="form-actions">
//               <button 
//                 type="button"
//                 className="cancel-btn"
//                 onClick={() => setIsModalOpen(false)}
//               >
//                 Bekor qilish
//               </button>
//               <button 
//                 type="submit"
//                 className="submit-btn"
//                 disabled={
//                   !formData.title_uz || 
//                   !formData.title_ru || 
//                   !formData.text_uz ||
//                   formData.images.length === 0
//                 }
//               >
//                 Yangilik qo'shish
//               </button>
//             </div>
//           </Form>
//         </Spin>
//       </Modal>
//     </div>
//   );
// };

// export default NewsPage;



import { useEffect, useState } from "react";
import { Button, Form, Input, Modal, Spin, message } from "antd";
import { useUserContext } from "../context/dashboard-context";
import NewsCard from "../components/product-card/news-card";
import CustomPagination from "../components/pagination";
import NewsImageUploader from "../components/imageUploader/NewsImageUploader";
import api from "../context/api";
import './news-page.scss';

const { TextArea } = Input;

const NewsPage = () => {
  const { token } = useUserContext();
  const [loading, setLoading] = useState(false);
  const [news, setNews] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalNews, setTotalNews] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [resetUploader, setResetUploader] = useState(0);

  const [formData, setFormData] = useState({
    title_uz: "",
    title_ru: "",
    title_en: "",
    text_uz: "",
    text_ru: "",
    text_en: "",
    images: []
  });

  const fetchNews = async (page = 1) => {
    setLoading(true);
    try {
      const response = await api.get(`/news/?page=${page}`);
      const data = Array.isArray(response.data) 
        ? response.data 
        : response.data.data || response.data.results || [];
      setNews(data);
      setTotalNews(response.data?.totalCount || response.data?.count || data.length);
    } catch (error) {
      console.error("Error fetching news:", error);
      message.error("Yangiliklarni yuklashda xatolik yuz berdi");
    } finally {
      setLoading(false);
    }
  };

  const addNews = async () => {
    if (formData.images.length === 0) {
      message.error("Iltimos, kamida bitta rasm yuklang");
      return;
    }
  
    setLoading(true);
    const formDataToSend = new FormData();
    
    Object.entries(formData).forEach(([key, value]) => {
      if (key !== 'images' && value !== null && value !== undefined) {
        formDataToSend.append(key, value);
      }
    });
    
    formData.images.forEach((image) => {
      formDataToSend.append('image_files', image);
    });

    try {
      const response = await api.post("/news/", formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        },
      });

      if ([200, 201].includes(response.status)) {
        message.success("Yangilik muvaffaqiyatli qo'shildi");
        fetchNews(currentPage);
        handleCancel();
      }
    } catch (error) {
      console.error("Error adding news:", error);
      message.error(error.response?.data?.message || "Yangilik qo'shishda xatolik yuz berdi");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
    setFormData({
      title_uz: "",
      title_ru: "",
      title_en: "",
      text_uz: "",
      text_ru: "",
      text_en: "",
      images: []
    });
    setResetUploader(prev => prev + 1);
  };

  useEffect(() => {
    fetchNews();
  }, []);

  const handleFormChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="news-page">
      <div className="page-header">
        <h1>Yangiliklar</h1>
        <button onClick={() => setIsModalOpen(true)}>
          + Yangi yangilik qo'shish
        </button>
      </div>

      {loading && news.length === 0 ? (
        <Spin size="large" />
      ) : news.length > 0 ? (
        <>
          <div className="news-grid">
            {news.map(item => (
              <NewsCard
                key={item.id}
                news={item}
                onUpdate={fetchNews}
              />
            ))}
          </div>
          
          <CustomPagination
            current={currentPage}
            total={totalNews}
            onChange={(page) => {
              setCurrentPage(page);
              fetchNews(page);
            }}
          />
        </>
      ) : (
        <div className="no-news">
          <p>Hozircha yangiliklar mavjud emas. Birinchi yangilikni qo'shing.</p>
        </div>
      )}

      <Modal
        title="Yangi yangilik qo'shish"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        width={800}
      >
        <Spin spinning={loading}>
          <Form form={form} onFinish={addNews}>
            <div className="form-section">
              <Form.Item label="Rasmlar" required>
                <NewsImageUploader
                  images={formData.images}
                  setImages={(images) => handleFormChange('images', images)}
                  resetTrigger={resetUploader}
                />
              </Form.Item>
              
              <Form.Item label="Sarlavha (O'zbekcha)" required>
                <Input
                  value={formData.title_uz}
                  onChange={(e) => handleFormChange('title_uz', e.target.value)}
                />
              </Form.Item>
              
              <Form.Item label="Sarlavha (Ruscha)" required>
                <Input
                  value={formData.title_ru}
                  onChange={(e) => handleFormChange('title_ru', e.target.value)}
                />
              </Form.Item>
              
              <Form.Item label="Sarlavha (Inglizcha)">
                <Input
                  value={formData.title_en}
                  onChange={(e) => handleFormChange('title_en', e.target.value)}
                />
              </Form.Item>
              
              <Form.Item label="Matn (O'zbekcha)" required>
                <TextArea
                  rows={4}
                  value={formData.text_uz}
                  onChange={(e) => handleFormChange('text_uz', e.target.value)}
                />
              </Form.Item>
              
              <Form.Item label="Matn (Ruscha)">
                <TextArea
                  rows={4}
                  value={formData.text_ru}
                  onChange={(e) => handleFormChange('text_ru', e.target.value)}
                />
              </Form.Item>
              
              <Form.Item label="Matn (Inglizcha)">
                <TextArea
                  rows={4}
                  value={formData.text_en}
                  onChange={(e) => handleFormChange('text_en', e.target.value)}
                />
              </Form.Item>
            </div>
            
            <div className="form-actions">
              <button 
                type="button"
                className="cancel-btn"
                onClick={handleCancel}
              >
                Bekor qilish
              </button>
              <button 
                type="submit"
                className="submit-btn"
                disabled={
                  !formData.title_uz || 
                  !formData.title_ru || 
                  !formData.text_uz ||
                  formData.images.length === 0
                }
              >
                Yangilik qo'shish
              </button>
            </div>
          </Form>
        </Spin>
      </Modal>
    </div>
  );
};

export default NewsPage;